import { gpPersonas } from '../const/gp-personas.const';
import { currentMainState } from '../game-plan.state';

export function createPersonaGroups(): void {
    const state = currentMainState();

    state.personaGroups = [];
    gpPersonas.forEach((value, key) => {
        state.personaGroups.push({
            personaType: key,
            persona: value,
            rows: null,
        });
    });
}
